import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export const useFetchOnInitialSyncQueryParams = ({
  key,
  onFetch,
}: {
  key: 'Invoices' | 'Payments' | 'Estimates'
  onFetch: () => void
}) => {
  const [searchParams] = useSearchParams()
  const isExpanded = searchParams.get('expanded') === key

  // Fetch initial data when the component is mounted and has search params
  useEffect(() => {
    if (isExpanded) {
      onFetch()
    }
  }, [])
}
